import { G_POP, SLASH_G_POP } from '@gp/constants/const';
import { queryUseSystem } from '@gp/utils/common';
import type { IBaseProps } from '@home/types/common';
import classnames from 'classnames';
import React from 'react';
import './index.scss';

interface ILinkJumpProps extends IBaseProps {
  // 跳转链接
  url: string;
  // 是否阻止冒泡
  stopPropagation?: boolean;
  // 是否阻止事件默认行为
  preventDefault?: boolean;
  // a标签是否一直需要
  isAlwaysElement?: boolean;
  // onClick回调
  onClick?: (e: React.MouseEvent) => void;
}

const generateUrl = (url: string): string => {
  if (!url || typeof url !== 'string') return 'javascript:;';
  if (url?.startsWith('http') || url?.startsWith('https')) return url;
  const { origin, pathname } = window.location;
  const baseUrl = `${origin}/${pathname?.split('/')?.[1]}`;

  if (url?.charAt(0) === '/' && url?.includes('/intelligence')) {
    return `${baseUrl}${url}`;
  }

  return url?.charAt(0) === '/'
    ? `${baseUrl}${url?.includes(SLASH_G_POP) ? '' : SLASH_G_POP}${url}`
    : `${baseUrl}${url?.includes(G_POP) ? '' : `/${G_POP}`}/${url}`;
};

/**
 * 注意：跳转到其它系统的话需要补全协议域名的完整链接，以防止跳转链接上加上了gp的系统前缀
 */
const LinkJump: React.FC<ILinkJumpProps> = (props) => {
  const {
    style,
    className,
    url: urlProps = '',
    stopPropagation: isStopPropagation = true,
    preventDefault: isPreventDefault = true,
    isAlwaysElement = false,
    onClick,
    children,
  } = props;

  const url = generateUrl(urlProps);

  // 新窗口打开跳转的页面
  const openPage = () => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.click();
  };

  return urlProps || isAlwaysElement ? (
    <a
      style={style}
      className={classnames('dbg-link-jump-el', className)}
      target=""
      href={url}
      onClick={(e) => {
        isStopPropagation && e.stopPropagation();
        isPreventDefault && e.preventDefault();
        const { win, mac } = queryUseSystem();
        // 使用了快捷键跳转
        if (win && e.ctrlKey) {
          e.stopPropagation();
          e.preventDefault();
          openPage();
          return;
        }
        if (mac && e.metaKey) {
          e.stopPropagation();
          e.preventDefault();
          openPage();
          return;
        }
        onClick?.(e);
      }}
    >
      {children}
    </a>
  ) : (
    children
  );
};

export default React.memo(LinkJump);
